<template>
	<div class="margin-for-nav">
		<page :category="category">
			<template slot="page" slot-scope="pageProps">
				<affixed-section :section="pageProps.section" :index="pageProps.index">
					<component :is="sectProps.component" slot-scope="sectProps" :section="sectProps.section" :side="sectProps.side"></component>
				</affixed-section>
			</template>
		</page>
  </div>
</template>

<script>
import Page from '@/components/Page.vue'
import { mapActions, mapGetters } from 'vuex'
import AffixedSection from '@/components/AffixedSection.vue'
import Section1 from '@/components/sections/projects/project3/Section1.vue'

export default {
	name: 'proj3',
	components: {
		Page,
    AffixedSection,
    Section1,
  },
  mounted: function () {
    this.showNav()
	},
  data: function () {
    return {
      category: 'Project3',
    }
	},
	methods: {
		...mapActions(['showNav'])
	},
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Project3.vue